module.exports = __webpack_public_path__ + "static/media/image-stack.926a1d94.png";